// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"0c291325","296":"2349e07d","302":"413a1011","524":"a97474cd","880":"ca1a1ce8"}[chunkId] + ".chunk.js";
};